/** Canvas anchors are authoritative for screen geometry; HTML controls remain accessible alternatives. */
export interface SemanticSurface {
  element: HTMLElement;
  rect(anchor: string): DOMRect | null;
  hovered(): { anchor: string; objectId: string | null } | null;
  anchors?(): { anchor: string; label: string; rect: { x: number; y: number; width: number; height: number } | null }[];
}
const surfaces = new Set<SemanticSurface>();
export const ANCHORS_CHANGED = 'board-anchors-changed';
export function registerSurface(surface: SemanticSurface) {
  surfaces.add(surface);
  const canvas = surface.element.querySelector('canvas') as (HTMLCanvasElement & { boardAnchors?: SemanticSurface['anchors'] }) | null;
  if (canvas && surface.anchors) canvas.boardAnchors = surface.anchors;
  return () => { surfaces.delete(surface); if (canvas) delete canvas.boardAnchors; invalidateAnchors(); };
}
export function anchorRect(anchor: string): DOMRect | null {
  for (const surface of surfaces) if (surface.element.isConnected) { const rect = surface.rect(anchor); if (rect) return rect; }
  return null;
}
export function hoveredBoardObject(element: Element | null) {
  for (const surface of surfaces) if (element && surface.element.contains(element)) return surface.hovered();
  return null;
}
export function invalidateAnchors() { if (typeof window !== 'undefined') window.dispatchEvent(new Event(ANCHORS_CHANGED)); }
